import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import useSeo from "@/hooks/useSeo";
import Hero from "./components/Hero";
import GenreSection from "./components/GenreSection";
import RankingSection from "./components/RankingSection";
import FeaturedSection from "./components/FeaturedSection";
import FeatureSection from "./components/FeatureSection";
import LatestSection from "./components/LatestSection";
import FaqSection from "./components/FaqSection";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "羞羞动漫漫画恋爱后宫题材专区",
  description:
    "汇集暧昧、同居、校园、逆后宫等热门恋爱后宫题材漫画，分类清晰，更新及时，追更不迷路。",
  url: "https://heartpark.github.io/",
  inLanguage: "zh-CN",
  mainEntity: {
    "@type": "ItemList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "恋爱漫画" },
      { "@type": "ListItem", position: 2, name: "后宫漫画" },
      { "@type": "ListItem", position: 3, name: "暧昧漫画" },
      { "@type": "ListItem", position: 4, name: "同居漫画" },
      { "@type": "ListItem", position: 5, name: "校园漫画" },
      { "@type": "ListItem", position: 6, name: "逆后宫漫画" },
    ],
  },
};

export default function Home() {
  useSeo({
    title: "羞羞动漫漫画恋爱后宫题材专区 - 暧昧、同居、校园、逆后宫漫画更新",
    description:
      "羞羞动漫漫画恋爱与后宫题材专区，汇集暧昧、同居、校园、逆后宫等热门漫画。分类清晰，更新及时，追更不迷路。",
    keywords:
      "羞羞动漫漫画,羞羞动漫漫画恋爱,羞羞动漫漫画后宫,羞羞动漫漫画暧昧,羞羞动漫漫画同居,羞羞动漫漫画校园,羞羞动漫漫画逆后宫",
    jsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <GenreSection />
        <FeaturedSection />
        <RankingSection />
        <FeatureSection />
        <LatestSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}